import { render } from "./SkyLottie.vue?vue&type=template&id=a2ce618a"
import script from "./SkyLottie.vue?vue&type=script&lang=js"
export * from "./SkyLottie.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__